
let arr = [
  'm-astable.bingex.com',
  'm-bstable.bingex.com',
  'm-cstable.bingex.com',
  'fat.bingex.com',
  // '10.2.16.109',
  // '10.2.16.247',
  // '10.2.23.162',
  '10.2.16.82'
]

let newScript = document.createElement('script')
for (let i = 0; i < arr.length; i++) {
  if (window.location.hostname.indexOf(arr[i]) !== -1) {
    newScript.setAttribute(
      'src',
      'https://cdn.ishansong.com/ishansong-fe-courier/courierView/static/plugin/vconsole.js'
    )
    newScript.async = true
    document.body.appendChild(newScript)
    newScript.addEventListener('load', function () {
      return new window.VConsole()
    })
  }
}
